"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = exports.StoreKey = void 0;
exports.StoreKey = {
    Config: 'dvc:config',
    User: 'dvc:user',
    AnonUser: 'dvc:anonymous_user'
};
var Store = /** @class */ (function () {
    function Store(localStorage) {
        this.store = localStorage;
    }
    Store.prototype.save = function (storeKey, data) {
        var _this = this;
        return this.modifyStore(function (storeKey) {
            var _a;
            (_a = _this.store) === null || _a === void 0 ? void 0 : _a.setItem(storeKey, JSON.stringify(data));
        }, storeKey);
    };
    Store.prototype.load = function (storeKey) {
        var _this = this;
        return new Promise(function (resolve) {
            var _a;
            resolve((_a = _this.store) === null || _a === void 0 ? void 0 : _a.getItem(storeKey));
        });
    };
    Store.prototype.clear = function (storeKey) {
        var _this = this;
        return this.modifyStore(function (storeKey) { var _a; return (_a = _this.store) === null || _a === void 0 ? void 0 : _a.removeItem(storeKey); }, storeKey);
    };
    Store.prototype.modifyStore = function (modify, storeKey) {
        try {
            return new Promise(function (resolve) {
                resolve(modify(storeKey));
            });
        }
        catch (e) {
            console.log(e);
            return null;
        }
    };
    Store.prototype.saveConfig = function (data) {
        return this.save(exports.StoreKey.Config, data);
    };
    Store.prototype.loadConfig = function () {
        return this.load(exports.StoreKey.Config);
    };
    Store.prototype.saveUser = function (user) {
        var _this = this;
        if (!user) {
            return Promise.reject('No user to save');
        }
        var saveUserPromise = this.save(exports.StoreKey.User, user);
        if (user.isAnonymous) {
            saveUserPromise.then(function () { return _this.save(exports.StoreKey.AnonUser, user); });
        }
        return saveUserPromise;
    };
    Store.prototype.loadUser = function () {
        return this.load(exports.StoreKey.User);
    };
    Store.prototype.loadAnonUser = function () {
        return this.load(exports.StoreKey.AnonUser);
    };
    return Store;
}());
exports.Store = Store;
exports.default = Store;
//# sourceMappingURL=Store.js.map